import m from "./ghl-ui.es786.js";
import o from "./ghl-ui.es1374.js";
import u from "./ghl-ui.es1220.js";
function b(e, n, r) {
  if (n = n || {}, r = new m(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return u(e, n, r.metadata) !== void 0;
  var l = n.v2 ? e.nationalNumber : e.phone;
  return o(l, r.nationalNumberPattern());
}
export {
  b as default
};
